/**
 * Simple local storage API provider
 *
 * @type {ngProvider}
 */
export class TmrLocalStorage {
  static ngType = 'provider'

  constructor(tmrApiPrefix) {
    'ngInject'
    Object.assign(this, { tmrApiPrefix })
  }

  get prefix() {
    // @todo This is not the overridden constant in brandings. Find a fix.
    return `tmr.${this.tmrApiPrefix}.`
  }

  $get($window, tmrApiPrefix) {
    'ngInject'
    // Re-inject the tmrApiPrefix service here, as a workaround for constant
    // being overridden too late in brandings.
    return new TmrLocalStorageService($window, `tmr.${tmrApiPrefix}.`)
  }
}

/**
 * Simple local storage API
 *
 * @alias TmrLocalStorage
 * @type {ngService}
 */
class TmrLocalStorageService {
  static ngType = 'service'

  constructor($window, prefix) {
    Object.assign(this, { localStorage: $window.localStorage, prefix })
  }

  key(key) {
    return this.prefix + key
  }

  /**
   * Gets a TMR local storage item.
   *
   * @param key         The storage key, without "tmr." prefix
   * @param defaultItem The item if not found in storage
   * @returns The item.
   */
  get(key, defaultItem) {
    let item = defaultItem
    if (typeof this.localStorage[this.key(key)] === 'string') {
      item = JSON.parse(this.localStorage[this.key(key)])
    } else if (item !== undefined) {
      this.localStorage[this.key(key)] = JSON.stringify(item)
    }
    return item
  }

  /**
   * Sets a TMR local storage item.
   * If `value` is not provided, the item is cleared.
   */
  set(key, value) {
    if (value === undefined) this.localStorage.removeItem(this.key(key))
    else this.localStorage[this.key(key)] = JSON.stringify(value)
  }

  /**
   * Clears TMR local storage items.
   * If key is provided, clears only key, otherwise clear all items.
   */
  clear(key) {
    if (key === undefined) {
      let remove = []
      for (let i = 0; i < this.localStorage.length; i++) {
        if (this.localStorage.key(i).indexOf(this.prefix) === 0) {
          remove.push(this.localStorage.key(i))
        }
      }
      remove.forEach(key => this.localStorage.removeItem(key))
    } else this.localStorage.removeItem(this.key(key))
  }
}
